import { defineStore } from 'pinia';
import { store } from '/@/store';
import { apis } from '/@/apis';
import { RolesRes } from '@lingtu/apis/entities';
import to from 'await-to-js';

const { ems } = apis;
interface RoleState {
  allRoles: RolesRes[];
  fetchingAllRoles: Boolean;
  roleValueEnum: Record<string, string>;
}

export const useRoleStore = defineStore({
  id: 'role',
  state: (): RoleState => ({
    allRoles: [],
    fetchingAllRoles: false,
    roleValueEnum: {
      MEMBER: 'member',
      ADMIN: 'admin',
      SUPER_ADMIN: 'superAdmin',
    },
  }),
  actions: {
    // 获取所有角色信息，如果已经存在信息不会重新获取
    async getAllRoles() {
      if (this.allRoles.length) {
        return this.allRoles;
      }
      const allRoles = await this.updateRoleList();

      return allRoles;
    },

    getRoleTitle(roleCode: string) {
      const role = this.getRole(roleCode);
      return role?.roleName;
    },

    getRole(roleCode: string) {
      return this.allRoles.find((v) => v.roleCode === roleCode);
    },

    // 重新所有角色信息
    async updateRoleList() {
      if (!this.fetchingAllRoles) {
        this.fetchingAllRoles = true;
        const [_, res] = await to(ems.roles());
        this.allRoles = res || [];
        this.fetchingAllRoles = false;
        return this.allRoles;
      } else {
        return await new Promise((resolve) => {
          this.$subscribe(() => {
            if (this.allRoles) {
              resolve(this.allRoles);
            }
          });
        });
      }
    },
  },
});

// 需要在设置之外使用
export function useRoleStoreWithOut() {
  return useRoleStore(store);
}
